export const locations = [
  { value: 'Alpnach', label: 'Alpnach'},
  // { value: 'Bern - Recruitment Day', label: 'Bern - Recruitment Day'},
  { value: 'Bern-Belp', label: 'Bern-Belp'},
  { value: 'Buochs', label: 'Buochs'},
  { value: 'Chur - Recruitment Day', label: 'Chur - Recruitment Day'},
  { value: 'Dübendorf - Tower', label: 'Dübendorf - Tower'},
  { value: 'Emmen', label: 'Emmen'},
  { value: 'Genève', label: 'Genève'},
  // { value: 'Genève - Recruitment Day', label: 'Genève - Recruitment Day'},
  { value: 'Genève Aéroport', label: 'Genève Aéroport'},
  { value: 'Grenchen', label: 'Grenchen'},
  // { value: 'Job Info special for Gamer', label: 'Job Info special for Gamer'},
  // { value: 'Locarno - Recruitment Day', label: 'Locarno - Recruitment Day'},
  // { value: 'Lugano - Recruitment Day', label: 'Lugano - Recruitment Day'},
  { value: 'Meiringen', label: 'Meiringen'},
  // { value: 'Meiringen - Recruitment Day', label: 'Meiringen - Recruitment Day'},
  { value: 'Online Job Info - Deutsch', label: 'Online Job Info - Deutsch'},
  { value: 'Online Job Info - English', label: 'Online Job Info - English'},
  { value: 'Online Job Info - Français', label: 'Online Job Info - Français'},
  { value: 'Online Job Info - Italiano', label: 'Online Job Info - Italiano'},
  // { value: 'Online Job Info MIL - Deutsch', label: 'Online Job Info MIL - Deutsch'},
  // { value: 'Online Job Info MIL - Français', label: 'Online Job Info MIL - Français'},
  // { value: 'Online job info MIL - Italian', label: 'Online job info MIL - Italian'},
  { value: 'Payerne', label: 'Payerne'},
  // { value: 'Payerne - Recruitment Day', label: 'Payerne - Recruitment Day'},
  { value: 'Sion', label: 'Sion'},
  // { value: 'Sion - Recruitment Day', label: 'Sion - Recruitment Day'},
  { value: 'St. Gallen', label: 'St. Gallen'},
  { value: 'Wangen bei Dübendorf', label: 'Wangen bei Dübendorf'},
  { value: 'Zürich-Flughafen', label: 'Zürich-Flughafen'},
];

export const feast_locations = [
  { value: 'Wangen bei Dübendorf', label: 'Wangen bei Dübendorf'},
  { value: 'Genève', label: 'Genève'},
  { value: 'Locarno - Recruitment Day', label: 'Recruitment Day Locarno'},
];

export const school_of_competence_locations = [
  { value: 'Dübendorf', label: 'Dübendorf'},
  { value: 'Genève', label: 'Geneva'},
  { value: 'MS Teams', label: 'MS Teams'},
];

export const DEFAULT_FILTERS = {
  event_type: '',
  start_date: null,
  end_date: null,
  location: '',
  language: ['English', 'French', 'Italian', 'German'],
};

export const DEFAULT_FEAST_FILTERS = {
  start_date: null,
  end_date: null,
  location: ['Wangen bei Dübendorf', 'Genève', 'Locarno - Recruitment Day'],
  language: ['English', 'French', 'Italian', 'German'],
};

export const DEFAULT_SCHOOL_OF_COMPETENCE_FILTERS = {
  start_date: null,
  end_date: null,
  competence: '',
};


